import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Input, Form } from "antd";
import { CLOUDFLARE_R2_IMAGE_HOSTING } from "../../utils/constant";

const formItemLayout = {
  labelCol: {
    xs: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 16 }
  }
};

@inject("imageHosting")
@observer
class CloudflareR2 extends Component {
  constructor(props) {
    super(props);
    const imageHosting = JSON.parse(
      localStorage.getItem(CLOUDFLARE_R2_IMAGE_HOSTING)
    );
    this.state = {
      imageHosting
    };
  }

  accountIdChange = e => {
    const { imageHosting } = this.state;
    imageHosting.accountId = e.target.value;
    this.setState({ imageHosting });
    localStorage.setItem(
      CLOUDFLARE_R2_IMAGE_HOSTING,
      JSON.stringify(imageHosting)
    );
  };

  accessKeyIdChange = e => {
    const { imageHosting } = this.state;
    imageHosting.accessKeyId = e.target.value;
    this.setState({ imageHosting });
    localStorage.setItem(
      CLOUDFLARE_R2_IMAGE_HOSTING,
      JSON.stringify(imageHosting)
    );
  };

  secretAccessKeyChange = e => {
    const { imageHosting } = this.state;
    imageHosting.secretAccessKey = e.target.value;
    this.setState({ imageHosting });
    localStorage.setItem(
      CLOUDFLARE_R2_IMAGE_HOSTING,
      JSON.stringify(imageHosting)
    );
  };

  bucketChange = e => {
    const { imageHosting } = this.state;
    imageHosting.bucket = e.target.value;
    this.setState({ imageHosting });
    localStorage.setItem(
      CLOUDFLARE_R2_IMAGE_HOSTING,
      JSON.stringify(imageHosting)
    );
  };

  customDomainChange = e => {
    const { imageHosting } = this.state;
    imageHosting.customDomain = e.target.value;
    this.setState({ imageHosting });
    localStorage.setItem(
      CLOUDFLARE_R2_IMAGE_HOSTING,
      JSON.stringify(imageHosting)
    );
  };

  uploadDomainChange = e => {
    const { imageHosting } = this.state;
    imageHosting.uploadDomain = e.target.value;
    this.setState({ imageHosting });
    localStorage.setItem(
      CLOUDFLARE_R2_IMAGE_HOSTING,
      JSON.stringify(imageHosting)
    );
  };

  render() {
    const {
      accountId,
      accessKeyId,
      secretAccessKey,
      bucket,
      customDomain,
      uploadDomain = ""
    } = this.state.imageHosting;
    return (
      <Form {...formItemLayout}>
        <Form.Item label="Account ID" style={style.formItem}>
          <Input
            value={accountId}
            onChange={this.accountIdChange}
            placeholder="例如：abc123def456"
          />
        </Form.Item>
        <Form.Item label="Access Key ID" style={style.formItem}>
          <Input
            value={accessKeyId}
            onChange={this.accessKeyIdChange}
            placeholder="例如：qweASDF1234zxcvb"
          />
        </Form.Item>
        <Form.Item label="Secret Access Key" style={style.formItem}>
          <Input
            value={secretAccessKey}
            onChange={this.secretAccessKeyChange}
            placeholder="例如：qweASDF1234zxcvbqweASD"
          />
        </Form.Item>
        <Form.Item label="Bucket" style={style.formItem}>
          <Input
            value={bucket}
            onChange={this.bucketChange}
            placeholder="例如：my-bucket"
          />
        </Form.Item>
        <Form.Item label="自定义域名" style={style.formItem}>
          <Input
            value={customDomain}
            onChange={this.customDomainChange}
            placeholder="例如：https://cdn.example.com"
          />
        </Form.Item>
        <Form.Item label="上传域名" style={style.formItem}>
          <Input
            value={uploadDomain}
            onChange={this.uploadDomainChange}
            placeholder="例如：https://upload.example.com"
          />
        </Form.Item>
        <Form.Item label="提示" style={style.formItem}>
          <span>配置后请在右上角进行切换，</span>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="https://developers.cloudflare.com/r2/"
          >
            Cloudflare R2 文档
          </a>
        </Form.Item>
      </Form>
    );
  }
}

const style = {
  formItem: {
    marginBottom: "10px"
  }
};

export default CloudflareR2;
